<template>
	<div class="basic_wrap">
		<div class="backgroud_bg">
			<img src="../images/index/red_bg.png" alt="" style="width: 100%;">
		</div>
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
		</div>
		<!-- 输入框 -->
		<div class="input_tab">
			<div class="geren_box">
				<div class="honour_left">
					<div class="honour_content">
						<img src="../images/index/jth-2.png" v-if="userlevel >= level" alt="" style="width: 100%;">
						<img src="../images/index/jth-3.png" v-else alt="" style="width: 100%;">
					</div>
				</div>
			</div>
			<div class="address_box">
				<div class="input_address">
					<input type="text" name="address" class="address" v-model="addressText" id="" placeholder="请填写详细邮寄地址">
				</div>
				<div class="input_phone">
					<input type="text" name="phone" class="phone" v-model="phoneText" id="" placeholder="请填写邮寄联系电话">
				</div>
				<div class="input_btn" @click="subArea">
					提交
				</div>
			</div>
			<div class="notice_box">
				<div class="notice_text">
					领取集体功勋须知:团员荣获集体功勋仅邮寄发放[集休功勋证书]
				</div>
				<div class="notice_text">
					团队长发放[集体功勋章][集体功勋锦旗] [集体功勋证书]
				</div>
			</div>
			<div class="go_btn" @click="goDiploma">
				<img src="../images/index/btn-1.png" alt="" style="width: 100%;">
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import Fetch from '../../utils/fetch';
	import Api from "../../interface/index";

	export default {
		name: "Information",
		components: {},
		data() {
			return {
				data: {},
				type:1,
				addressText:'',
				phoneText:'',
				userlevel:0,
				level:12,
				userid:'',
			};
		},
		created() {
			this.userid = localStorage.getItem('login_userid');
			this.userlevel = localStorage.getItem('login_userlevel');
			this.addressText = localStorage.getItem('login_addressarea') != 'null'?localStorage.getItem('login_addressarea'):'';
			this.phoneText = localStorage.getItem('login_addressphone') != 'null'?localStorage.getItem('login_addressphone'):'';
			this.$parent.footer('info', false);
			if (this.$router.history.current.query.type) {
				this.type = parseInt(this.$router.history.current.query.type);
			}
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				
			},
			subArea(){
				Fetch('/index/addArea','post', {
					user_id: this.userid,
					address_area: this.addressText,
					address_phone: this.phoneText,
				}).then(res => {
					if(res.code == 1){
						this.$toast({
							className:"toastName",
							message: res.msg,
						});
					}else{
						localStorage.setItem('login_addressarea', this.addressText);
						localStorage.setItem('login_addressphone', this.phoneText);
						this.$toast({
							className:"toastName",
							message: res.msg,
						},2000);
					}
				})
			},
			changeInputBox(obj){
				if(obj == 1){
					this.box1 = false;
					this.box2 = true;
				}else if(obj == 2){
					this.box2 = false;
					this.box3 = true;
				}else if(obj == 3){
					this.box3 = false;
					this.box4 = true;
				}else if(obj == 4){
					this.$router.push('/infoResult');
				}
			},
			goDiploma(){
				this.$router.push('/infoDiploma?type=2');
			}
		},
	};
</script>

<style lang="less" scoped>
	.red_top_bg{
	    position: fixed;
	    top: 0;
	    z-index: 10;
		background-image:none;
		
		.back_left {
			background: url(../../views/images/back_b.png) no-repeat center center;
		}
		.big_tit{
			color: #ffffff;
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 1;
			overflow: hidden;
		}
	}
	.backgroud_bg{
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
	}
	.input_tab {
	    position: absolute;
	    width: 100%;
	    z-index: 9;
		
		.geren_box {
		    position: relative;
		    z-index: 9;
		    display: flex;
		    justify-content: center;
			height: 8.2rem;
			
			.honour_left {
			    position: relative;
				
				.honour_content {
				    position: relative;
				    z-index: 9;
				    width: 54%;
				    left: 23%;
				    top: 16%;
				}
			}
			.honour_right {
			    position: relative;
				width: 5rem;
				margin-top: 1rem;
				left: 0.2rem;
				
				.user_name {
				    position: relative;
				    z-index: 9;
				    text-align: center;
				    top: 25%;
				    left: 0.25rem;
				    font-size: 0.3rem;
				    font-weight: 800;
				}
			}
		}
		.address_box {
		    position: relative;
		    z-index: 9;
		    width: 80%;
		    left: 10%;
			    margin-top: 0.4rem;
			
			.input_address {
			    height: 1rem;
			    line-height: 1rem;
			    background-color: #fff;
			    color: #000;
			    border-radius: 0.2rem;
				text-align: center;
				    font-size: 0.6rem;
			}
			.input_phone {
			    height: 1rem;
			    line-height: 1rem;
			    background-color: #fff;
			    color: #000;
			    border-radius: 0.2rem;
				margin-top: 0.2rem;
				text-align: center;
				    font-size: 0.6rem;
			}
			.input_btn {
			    height: 1rem;
			    line-height: 1rem;
			    background-color: #fff;
			    color: #000;
			    border-radius: 0.2rem;
				margin-top: 0.2rem;
				text-align: center;
				    font-size: 0.6rem;
			}
			input::placeholder {
			    text-align: center;
			}
		}
		.notice_box {
		    position: relative;
		    z-index: 9;
		    width: 80%;
		    left: 10%;
		    margin-top: 0.5rem;
		    font-size: 0.4rem;
		    color: #f7e78a;
			
			.notice_text {
			    line-height: 1.5;
			}
		}
		.go_btn {
		    position: relative;
		    z-index: 9;
		    width: 70%;
		    left: 15%;
		    margin-top: 0.2rem;
		}
	}
	
</style>
